import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { AudioMediaSchema } from "../../fragments/Media";
export const AudioItemBladeSchema = BladeCommonSchema.extend({
    audio: AudioMediaSchema,
    caption: z.string().optional(),
});
export const AudioItemBladeTypeValues = ["audioPlayer"];
export const AudioItemBladeTypesSchema = z.enum(AudioItemBladeTypeValues);
export const AudioItemBladeTypes = AudioItemBladeTypesSchema.enum;
export const AudioPlayerBladesContractSchema = AudioItemBladeSchema.extend({
    type: AudioItemBladeTypesSchema,
});
export const AudioPlayerContractSchema = AudioItemBladeSchema.extend({
    type: z.literal(AudioItemBladeTypes.audioPlayer),
});
//# sourceMappingURL=index.js.map